import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { SubscriptionLobbyContent } from "./common.types";

export const commonApi = createApi({
  reducerPath: "commonApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST,
    credentials: "include",
  }),
  tagTypes: ["Subscription"],
  endpoints: build => ({
    getSubscriptionPlan: build.query<SubscriptionPlanUser, void>({
      queryFn: async (_arg, api, extraOptions, baseQuery) => {
        const result = await baseQuery("/api/subscriptions/getSubscriptionPlan");
        if (result.error) return { error: result.error };
        return { data: result.data as SubscriptionPlanUser };
      },
      providesTags: ["Subscription"],
    }),
    getSubscriptionLobbyContent: build.query<SubscriptionLobbyContent, void>({
      query: () => `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/SubscriberCompetition/GetsubscriptionLobbyContent`,
    }),
  }),
});

export const { useGetSubscriptionPlanQuery, useGetSubscriptionLobbyContentQuery } = commonApi;
